module.exports = __webpack_public_path__ + "media/social-facebook-1d220494.svg";